module.exports = __webpack_public_path__ + "img/group-1.df952370.png";